<template>
  <div>
    <div class="mensagem-tela-container">
      <font-awesome-icon class="mensagem-tela-icone" icon="exclamation-circle" />
      O sistema foi desenvolvido para utilização em navegadores com configuração de janela acima de
      1000x500 pixels e por isso algumas funcionalidades podem ficar inacessíveis.
    </div>
  </div>
</template>

<script>
export default {
  name: "MensagemTela"
};
</script>

<style lang="scss" scoped>
.mensagem-tela-container {
  min-height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  z-index: 10000000;
  background: var(--vermelho0);
  color: var(--vermelho4);
}
.mensagem-tela-icone {
  font-size: 30px;
  margin-right: 10px;
}
</style>
